import { useState } from "react";
import { Col, Row } from "@/utils/bootstrap";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import SVgMapSearch from "./SVgMapSearch";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  onSelect: (position: google.maps.LatLngLiteral) => void;
}
const GoogleMapsSearch: React.FC<Props> = ({ onSelect }) => {
  const [address, setAddress] = useState("");
  const t = useTranslation();
  const handleChange = (address: any) => {
    setAddress(address);
  };

  const handleSelect = (address: string) => {
    geocodeByAddress(address)
      .then((results: any) => getLatLng(results[0]))
      .then((latLng: any) => {
        onSelect(latLng);
      })
      .catch((_error: any) => {})
  };
  const TsPlacesAutocomplete: any = PlacesAutocomplete;
  return (
    <div className="search-container">
      <TsPlacesAutocomplete
        value={address}
        onChange={handleChange}
        onSelect={handleSelect}
      >
        {({
          getInputProps,
          suggestions,
          getSuggestionItemProps,
          loading,
        }: any) => (
          <Row className="m-0">
            <Col className="col-auto">
              <SVgMapSearch />
            </Col>
            <Col className="p-0">
              <input
                {...getInputProps({
                  placeholder: t.map_search_placeholder,
                  className: "search-box",
                })}
              />
            </Col>
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion: any, key: number) => {
                const className = suggestion.active
                  ? "suggestion-item--active"
                  : "suggestion-item";
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: "#fafafa", cursor: "pointer" }
                  : { backgroundColor: "#ffffff", cursor: "pointer" };
                return (
                  <div
                    key={key}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </Row>
        )}
      </TsPlacesAutocomplete>
    </div>
  );
};
export default GoogleMapsSearch;
